/**
 * PocketFiler - Korean (ko) Translation File
 * Complete translation - all keys from en.js
 */

const ko = {
  "nav.login": "로그인",
  "nav.signup": "시작하기",
  "nav.logout": "로그아웃",
  "nav.dashboard": "대시보드",
  "nav.virtualOffices": "가상 오피스",
  "nav.clients": "고객",
  "nav.deals": "거래",
  "nav.documents": "문서",
  "nav.messages": "메시지",
  "nav.settings": "설정",
  "nav.invoices": "청구서",
  "nav.templates": "템플릿",
  "nav.tasks": "작업",
  "nav.meetings": "회의",
  "nav.analytics": "분석",
  "landing.badge": "AI 기반 거래 플랫폼",
  "landing.hero.title": "AI로 모든 언어에서 중요한 거래 완료",
  "landing.hero.titleHighlight": "AI로",
  "landing.hero.subtitle": "PocketFiler는 기업과 개인이 글로벌 무역부터 지역 자동차 판매, 보험 정책까지 문서 중심의 신뢰도 높은 거래를 수행할 수 있도록 지원합니다. AI 번역, 문서 워크플로우, 모든 거래를 위한 딜룸을 제공합니다.",
  "landing.hero.cta.start": "무료로 시작",
  "landing.hero.cta.demo": "작동 방식 보기",
  "landing.useCases.title": "글로벌 무역, 지역 서비스, 대규모 개인 거래를 위해 구축",
  "landing.useCases.subtitle": "해외에서 상품을 수입하든 동네에서 차를 팔든, PocketFiler는 자신감 있게 거래를 마무리할 수 있는 도구를 제공합니다.",
  "landing.useCases.globalTrade.title": "글로벌 무역 및 제조",
  "landing.useCases.globalTrade.desc": "해외 공급업체를 찾고 협력하며, 규정 준수 문서를 수집하고, 실시간 번역으로 딜룸에서 협상합니다.",
  "landing.useCases.insurance.title": "보험, 대출 및 전문 서비스",
  "landing.useCases.insurance.desc": "고객을 초대하여 신분증, 명세서, 양식을 모국어로 업로드하게 하고, 가상 오피스에서 모든 문서와 메시지를 추적합니다.",
  "landing.useCases.realEstate.title": "부동산 거래",
  "landing.useCases.realEstate.desc": "구매자와 세입자를 여러 언어로 신청, 공개, 계약을 안내하며, 모든 것을 거래당 하나의 딜룸에서 처리합니다.",
  "landing.useCases.vehicle.title": "개인 차량 및 자산 판매",
  "landing.useCases.vehicle.desc": "딜룸과 AI 생성 계약서를 사용하여 자동차, 장비 및 기타 고가 품목의 매매 문서를 처리합니다.",
  "landing.audience.title": "개인과 팀 모두를 위해 설계",
  "landing.audience.individuals.title": "개인용",
  "landing.audience.individuals.bullet1": "자동차 구매, 장비 또는 고가 품목과 같은 중요한 일회성 거래를 명확한 기록으로 완료합니다.",
  "landing.audience.individuals.bullet2": "간단하고 안전한 링크를 사용하여 휴대폰에서 문서를 업로드하고 계약서를 검토합니다.",
  "landing.audience.individuals.bullet3": "거래가 완료된 후에도 각 거래의 모든 메시지, 파일, 계약서 초안을 한 곳에 보관합니다.",
  "landing.audience.teams.title": "기업 및 팀용",
  "landing.audience.teams.bullet1": "각 서비스 라인(보험, 부동산, 대출, 수입)에 맞춤 체크리스트가 있는 가상 오피스를 설정합니다.",
  "landing.audience.teams.bullet2": "모든 언어의 고객을 초대하여 문서를 업로드하고, 계약서에 서명하고, 딜룸에서 소통합니다.",
  "landing.audience.teams.bullet3": "팀에게 타임라인, AI 요약, 각 거래의 전체 기록이 있는 공유 작업 공간을 제공합니다.",
  "landing.howItWorks.title": "PocketFiler가 모든 거래에서 작동하는 방법",
  "landing.howItWorks.subtitle": "거래를 더 빠르고 마찰 없이 완료할 수 있도록 함께 작동하는 4가지 강력한 기능.",
  "landing.howItWorks.concierge.title": "AI 컨시어지",
  "landing.howItWorks.concierge.desc": "AI 어시스턴트가 비즈니스를 학습하고, 적절한 가상 오피스를 설정하며, 각 거래 유형에 맞는 문서 체크리스트를 구성합니다.",
  "landing.howItWorks.translation.title": "자동 번역",
  "landing.howItWorks.translation.desc": "메시지와 핵심 콘텐츠가 당사자 간에 즉시 번역되어 구매자, 판매자, 고객이 자신의 언어로 소통할 수 있습니다.",
  "landing.howItWorks.documents.title": "스마트 문서",
  "landing.howItWorks.documents.desc": "고객이 휴대폰에서 문서를 업로드하면 AI가 주요 필드를 추출하고, 품질을 확인하며, 거래를 지연시키기 전에 문제에 플래그를 지정합니다.",
  "landing.howItWorks.dealRooms.title": "딜룸 및 계약",
  "landing.howItWorks.dealRooms.desc": "각 거래에는 타임라인, 메시지, 문서, 검토하고 최종화할 수 있는 AI 생성 계약서 초안이 있는 전용 룸이 제공됩니다.",
  "landing.cta.title": "다음 거래를 완료할 준비가 되셨나요?",
  "landing.cta.subtitle": "PocketFiler를 사용하여 중요한 거래를 자신감 있게 처리하는 기업과 개인에 합류하세요.",
  "landing.cta.button": "무료 계정 만들기",
  "landing.footer.tagline": "중요한 거래를 간단하게.",
  "language.picker.title": "언어를 선택하세요",
  "language.picker.subtitle": "모든 안내, 메시지, 계약서를 이 언어로 보여드립니다. 다른 사람들은 자신의 언어를 선택할 수 있으며, AI가 번역을 처리합니다.",
  "language.picker.continue": "계속",
  "language.picker.playSample": "샘플 재생",
  "language.picker.playing": "재생 중...",
  "language.picker.confirmation": "{language}을(를) 선택하셨습니다. 모든 것을 이 언어로 보여드립니다. 다른 사람들은 자신의 언어를 선택할 수 있으며, PocketFiler는 메시지, 문서, 계약서를 번역하여 모두가 이해할 수 있도록 합니다.",
  "language.toast.saved": "언어가 저장되었습니다! 변경하려면 프로필의 설정으로 이동하세요.",
  "language.confirm.title": "언어 확인",
  "language.confirm.subtitle": "이 언어는 모든 UI, 메시지, 계약서에 사용됩니다.",
  "language.confirm.change": "언어 변경",
  "language.confirm.continue": "계속",
  "language.confirm.chineseNote": "참고: 간체 중국어(简体中文)를 선택했습니다. 번체 중국어를 선호하시면 선택을 변경해 주세요.",
  "auth.login.title": "다시 오신 것을 환영합니다",
  "auth.login.subtitle": "PocketFiler 계정에 로그인",
  "auth.login.email": "이메일",
  "auth.login.password": "비밀번호",
  "auth.login.submit": "로그인",
  "auth.login.noAccount": "계정이 없으신가요?",
  "auth.login.signupLink": "가입하기",
  "auth.login.error": "이메일 또는 비밀번호가 잘못되었습니다",
  "auth.signup.title": "계정 만들기",
  "auth.signup.subtitle": "모든 언어로 거래 시작",
  "auth.signup.name": "이름",
  "auth.signup.email": "이메일",
  "auth.signup.password": "비밀번호",
  "auth.signup.confirmPassword": "비밀번호 확인",
  "auth.signup.companyName": "회사명",
  "auth.signup.companyType": "업종",
  "auth.signup.submit": "계정 만들기",
  "auth.signup.hasAccount": "이미 계정이 있으신가요?",
  "auth.signup.loginLink": "로그인",
  "auth.signup.terms": "가입하면 서비스 약관 및 개인정보 보호정책에 동의하게 됩니다.",
  "dashboard.title": "대시보드",
  "dashboard.welcome": "다시 오신 것을 환영합니다, {name}",
  "dashboard.aiSummary.title": "AI 요약",
  "dashboard.aiSummary.generating": "요약 생성 중...",
  "dashboard.stats.totalDeals": "총 거래",
  "dashboard.stats.activeDeals": "활성 거래",
  "dashboard.stats.totalClients": "총 고객",
  "dashboard.stats.documentsProcessed": "처리된 문서",
  "dashboard.recentDeals.title": "최근 거래",
  "dashboard.recentDeals.viewAll": "모두 보기",
  "dashboard.recentDeals.empty": "아직 거래가 없습니다. 첫 거래를 만들어 시작하세요.",
  "dashboard.recentClients.title": "최근 고객",
  "dashboard.recentClients.viewAll": "모두 보기",
  "dashboard.recentClients.empty": "아직 고객이 없습니다. 첫 고객을 초대하여 시작하세요.",
  "dashboard.quickActions.title": "빠른 작업",
  "dashboard.quickActions.createDeal": "거래 만들기",
  "dashboard.quickActions.inviteClient": "고객 초대",
  "dashboard.quickActions.createOffice": "가상 오피스 만들기",
  "offices.title": "가상 오피스",
  "offices.subtitle": "서비스 유형별로 비즈니스 정리",
  "offices.create": "가상 오피스 만들기",
  "offices.empty.title": "아직 가상 오피스가 없습니다",
  "offices.empty.desc": "첫 번째 가상 오피스를 만들어 거래와 고객을 정리하세요.",
  "offices.card.clients": "{count}명의 고객",
  "offices.card.deals": "{count}건의 거래",
  "offices.card.checklist": "체크리스트 항목",
  "offices.checklist": "문서 체크리스트",
  "offices.noChecklist": "필요한 문서 없음",
  "offices.dialog.title": "가상 오피스 만들기",
  "offices.dialog.desc": "특정 서비스 유형을 위한 새 작업 공간 설정",
  "offices.dialog.name": "오피스 이름",
  "offices.dialog.namePlaceholder": "예: 보험 청구, 부동산 판매",
  "offices.dialog.type": "오피스 유형",
  "offices.dialog.description": "설명",
  "offices.dialog.descriptionPlaceholder": "이 오피스가 처리하는 내용을 설명하세요...",
  "offices.dialog.checklist": "문서 체크리스트",
  "offices.dialog.checklistHelp": "필요한 문서에 대한 AI 생성 체크리스트",
  "offices.dialog.addItem": "항목 추가",
  "offices.dialog.generateChecklist": "AI로 생성",
  "offices.dialog.creating": "생성 중...",
  "offices.dialog.create": "오피스 만들기",
  "offices.form.name": "오피스 이름",
  "offices.form.namePlaceholder": "예: 보험 서비스, 부동산 등",
  "offices.form.description": "설명",
  "offices.form.descPlaceholder": "이 오피스에서 어떤 유형의 거래를 처리할 예정인가요?",
  "offices.form.checklistPlaceholder": "필요한 문서 추가...",
  "offices.ai.title": "AI 지원 설정",
  "offices.ai.desc": "AI 컨시어지가 비즈니스 요구 사항에 대해 질문하여 완벽한 가상 오피스를 설정하도록 도와드립니다.",
  "offices.ai.manual": "수동으로 설정",
  "offices.ai.start": "AI 설정 시작",
  "offices.ai.startOnboarding": "가상 오피스 설정을 도와주세요",
  "offices.ai.suggestion": "AI 제안",
  "offices.ai.acceptSuggestion": "수락 및 오피스 만들기",
  "offices.ai.inputPlaceholder": "응답을 입력하세요...",
  "clients.title": "고객",
  "clients.subtitle": "고객 및 초대 관리",
  "clients.invite": "고객 초대",
  "clients.empty.title": "아직 고객이 없습니다",
  "clients.empty.desc": "첫 번째 고객을 초대하여 시작하세요.",
  "clients.table.name": "이름",
  "clients.table.client": "고객",
  "clients.table.contact": "연락처",
  "clients.table.office": "오피스",
  "clients.table.language": "언어",
  "clients.table.status": "상태",
  "clients.table.actions": "작업",
  "clients.status.invited": "초대됨",
  "clients.status.active": "활성",
  "clients.status.completed": "완료됨",
  "clients.dialog.title": "새 고객 초대",
  "clients.dialog.name": "고객 이름",
  "clients.dialog.email": "이메일 주소",
  "clients.dialog.phone": "전화번호",
  "clients.dialog.office": "가상 오피스",
  "clients.dialog.language": "선호 언어",
  "clients.dialog.sending": "초대장 발송 중...",
  "clients.dialog.send": "초대장 발송",
  "clients.toast.invited": "{name}에게 초대장을 발송했습니다",
  "clients.toast.deleted": "고객이 삭제되었습니다",
  "clients.toast.linkCopied": "초대 링크가 클립보드에 복사되었습니다",
  "clients.invite.step1Title": "새 고객 초대",
  "clients.invite.step2Title": "초대 메시지 미리보기",
  "clients.invite.step3Title": "초대 완료!",
  "clients.invite.step1Desc": "고객 연락처 정보 입력",
  "clients.invite.step2Desc": "초대 메시지 검토 및 커스터마이즈",
  "clients.invite.step3Desc": "고객에게 초대 링크 공유",
  "clients.invite.nameLabel": "고객 이름",
  "clients.invite.namePlaceholder": "예: 홍길동",
  "clients.invite.contactMethod": "연락 방법",
  "clients.invite.phone": "전화번호",
  "clients.invite.customNote": "커스텀 메모",
  "clients.invite.customNotePlaceholder": "이 고객을 위한 특별 지침...",
  "clients.invite.previewMessage": "메시지 미리보기",
  "clients.invite.aiGenerated": "AI 생성 초대 메시지",
  "clients.invite.messagePreview": "메시지 미리보기",
  "clients.invite.messageEditHint": "보내기 전에 이 메시지를 편집할 수 있습니다",
  "clients.invite.documentsRequested": "요청된 문서",
  "clients.invite.regenerate": "메시지 다시 생성",
  "clients.invite.sendInvite": "초대 보내기",
  "clients.invite.linkCreated": "초대 링크가 생성되었습니다!",
  "clients.invite.linkCopiedToClipboard": "링크가 클립보드에 복사되었습니다",
  "clients.invite.shareLink": "이메일, SMS 또는 직접 이 링크를 고객과 공유하세요",
  "clients.invite.inviteAnother": "다른 고객 초대",
  "clients.invite.success": "고객이 초대되었습니다!",
  "clients.invite.linkCopied": "초대 링크가 복사되었습니다!",
  "clients.invite.yourAgent": "담당자",
  "clients.invite.defaultOffice": "저희 오피스",
  "deals.title": "거래",
  "deals.subtitle": "거래 추적 및 관리",
  "deals.create": "거래 만들기",
  "deals.empty.title": "아직 거래가 없습니다",
  "deals.empty.desc": "첫 번째 거래를 만들어 시작하세요.",
  "deals.search": "거래 검색...",
  "deals.filter.all": "모든 거래",
  "deals.filter.active": "활성",
  "deals.filter.pending": "보류 중",
  "deals.filter.closed": "완료됨",
  "deals.column.draft": "초안",
  "deals.column.active": "활성",
  "deals.column.pending": "보류 중",
  "deals.column.closed": "완료됨",
  "deals.card.documents": "{count}개의 문서",
  "deals.card.messages": "{count}개의 메시지",
  "deals.dialog.title": "새 거래 만들기",
  "deals.dialog.dealTitle": "거래 제목",
  "deals.dialog.dealTitlePlaceholder": "예: 차량 구매 - 2023 Honda Civic",
  "deals.dialog.client": "고객",
  "deals.dialog.office": "가상 오피스",
  "deals.dialog.type": "거래 유형",
  "deals.dialog.notes": "메모",
  "deals.dialog.notesPlaceholder": "이 거래에 대한 메모를 추가하세요...",
  "deals.dialog.creating": "생성 중...",
  "deals.dialog.create": "거래 만들기",
  "dealRoom.back": "거래로 돌아가기",
  "dealRoom.readOnly.title": "읽기 전용",
  "dealRoom.readOnly.closedMessage": "이 거래가 완료되었습니다. 딜룸은 이제 참조 및 감사 목적으로 읽기 전용입니다.",
  "dealRoom.readOnly.cancelledMessage": "이 거래가 취소되었습니다. 딜룸은 이제 참조 및 감사 목적으로 읽기 전용입니다.",
  "dealRoom.tabs.messages": "메시지",
  "dealRoom.tabs.documents": "문서",
  "dealRoom.tabs.contract": "계약서",
  "dealRoom.timeline.title": "활동 타임라인",
  "dealRoom.timeline.empty": "아직 활동이 없습니다",
  "dealRoom.details.title": "거래 상세",
  "dealRoom.details.notes": "메모",
  "dealRoom.details.type": "유형",
  "dealRoom.details.documents": "문서",
  "dealRoom.details.messages": "메시지",
  "dealRoom.aiSummary.title": "AI 요약",
  "dealRoom.aiSummary.generating": "요약 생성 중...",
  "dealRoom.messages.empty": "아직 메시지가 없습니다. 대화를 시작하세요.",
  "dealRoom.messages.placeholder": "메시지를 입력하세요...",
  "dealRoom.messages.send": "보내기",
  "dealRoom.messages.sending": "보내는 중...",
  "dealRoom.messages.showOriginal": "원문 보기",
  "dealRoom.messages.showTranslation": "번역 보기",
  "dealRoom.messages.translatedFrom": "{language}에서 번역됨",
  "dealRoom.messages.suggestReply": "답장 제안",
  "dealRoom.documents.empty": "아직 업로드된 문서가 없습니다.",
  "dealRoom.documents.upload": "문서 업로드",
  "dealRoom.documents.uploading": "업로드 중...",
  "dealRoom.documents.analyze": "분석",
  "dealRoom.documents.analyzing": "분석 중...",
  "dealRoom.documents.download": "다운로드",
  "dealRoom.documents.delete": "삭제",
  "dealRoom.documents.pending": "분석 대기 중",
  "dealRoom.documents.analyzed": "분석됨",
  "dealRoom.documents.aiAnalysis": "AI 문서 분석",
  "dealRoom.documents.type": "문서 유형",
  "dealRoom.documents.confidence": "신뢰도",
  "dealRoom.documents.summary": "요약",
  "dealRoom.documents.issues": "문제점",
  "dealRoom.contract.empty.title": "아직 생성된 계약서가 없습니다",
  "dealRoom.contract.empty.desc": "이 거래에 대한 AI 계약서 초안을 생성하세요.",
  "dealRoom.contract.generate": "계약서 초안 생성",
  "dealRoom.contract.regenerate": "계약서 다시 생성",
  "dealRoom.contract.generating": "생성 중...",
  "dealRoom.contract.aiLabel": "AI 생성 계약서 초안",
  "dealRoom.contract.language": "언어",
  "dealRoom.contract.copy": "복사",
  "dealRoom.contract.copied": "클립보드에 복사됨",
  "dealRoom.contract.type": "계약서 유형",
  "dealRoom.contract.generated": "생성됨",
  "dealRoom.contract.languages": "언어",
  "dealRoom.contract.status": "상태",
  "dealRoom.contract.notice": "AI 문서 분석: 하나 이상의 조항이 선택한 언어 간에 직접적인 동등어가 없습니다. 설명적 언어를 사용했습니다. 이러한 섹션을 주의 깊게 검토하고 필요한 경우 상대방에게 확인하세요.",
  "dealRoom.contract.dialog.title": "계약서 초안 생성",
  "dealRoom.contract.dialog.desc": "AI가 거래 세부 정보를 기반으로 이중 언어 계약서를 생성합니다.",
  "dealRoom.contract.dialog.disclaimer": "이것은 검토 목적으로 AI가 생성한 초안입니다. 서명하기 전에 법률 전문가의 검토를 받으세요.",
  "dealRoom.contract.dialog.type": "계약서 유형",
  "dealRoom.contract.dialog.languages": "언어",
  "dealRoom.contract.dialog.languagesHelp": "이중 언어 계약서에 두 가지 언어를 선택하세요. 모든 Tier 1 언어가 완전히 지원됩니다.",
  "dealRoom.contract.dialog.primary": "기본",
  "dealRoom.contract.dialog.secondary": "보조",
  "dealRoom.contract.dialog.terms": "특별 조건",
  "dealRoom.contract.dialog.termsPlaceholder": "특별 조건이나 조항을 추가하세요...",
  "dealRoom.contract.dialog.generate": "계약서 생성",
  "dealRoom.contract.dialog.generating": "생성 중...",
  "dealRoom.status.change": "상태 변경",
  "dealRoom.status.dialog.title": "거래 상태 변경",
  "dealRoom.status.dialog.from": "변경 전",
  "dealRoom.status.dialog.to": "변경 후",
  "dealRoom.status.dialog.reason": "사유 (선택사항)",
  "dealRoom.status.dialog.reasonPlaceholder": "상태를 변경하는 이유는 무엇인가요?",
  "dealRoom.status.dialog.confirm": "변경 확인",
  "dealRoom.status.dialog.changing": "변경 중...",
  "dealRoom.status.toast.changed": "상태가 {status}(으)로 변경되었습니다",
  "dealRoom.upgrade.title": "비즈니스로 업그레이드",
  "dealRoom.upgrade.desc": "계약서 생성에는 비즈니스 플랜이 필요합니다.",
  "dealRoom.upgrade.features": "비즈니스를 사용하면:",
  "dealRoom.upgrade.feature1": "AI 생성 계약서 초안",
  "dealRoom.upgrade.feature2": "고급 문서 분석",
  "dealRoom.upgrade.feature3": "우선 지원",
  "dealRoom.upgrade.button": "지금 업그레이드",
  "settings.title": "설정",
  "settings.subtitle": "계정 및 조직 관리",
  "settings.tabs.profile": "프로필",
  "settings.tabs.organization": "조직",
  "settings.profile.title": "프로필 설정",
  "settings.profile.subtitle": "개인 정보 관리",
  "settings.profile.name": "이름",
  "settings.profile.email": "이메일",
  "settings.profile.emailNote": "이메일은 변경할 수 없습니다",
  "settings.profile.language": "선호 언어",
  "settings.profile.languageHelp": "모든 UI, 메시지, 계약서가 이 언어로 표시됩니다.",
  "settings.profile.save": "변경 사항 저장",
  "settings.profile.saving": "저장 중...",
  "settings.profile.saved": "프로필이 업데이트되었습니다",
  "settings.org.title": "조직 설정",
  "settings.org.subtitle": "비즈니스 정보 관리",
  "settings.org.name": "조직 이름",
  "settings.org.type": "업종",
  "settings.org.billingEmail": "청구 이메일",
  "settings.org.plan": "플랜",
  "settings.org.verification": "인증 상태",
  "settings.org.save": "변경 사항 저장",
  "settings.org.saving": "저장 중...",
  "settings.org.saved": "조직이 업데이트되었습니다",
  "settings.org.noOrg": "조직을 찾을 수 없습니다",
  "invite.language.title": "언어를 선택하세요",
  "invite.language.subtitle": "모든 안내를 귀하의 언어로 보여드립니다.",
  "invite.welcome.title": "환영합니다",
  "invite.welcome.subtitle": "귀하의 문서를 받을 준비가 되었습니다.",
  "invite.welcome.time": "5-10분",
  "invite.welcome.timeLabel": "예상 소요 시간",
  "invite.welcome.secure": "안전하고 무료",
  "invite.welcome.secureDesc": "귀하의 문서는 암호화됩니다. 이 서비스는 무료입니다.",
  "invite.welcome.start": "업로드 시작",
  "invite.documents.needed": "필요한 문서",
  "invite.upload.title": "문서 업로드",
  "invite.upload.dragDrop": "여기에 파일을 끌어다 놓거나 클릭하여 선택하세요",
  "invite.upload.or": "또는",
  "invite.upload.takePhoto": "이미지",
  "invite.upload.browse": "파일",
  "invite.upload.uploading": "업로드 중...",
  "invite.upload.analyzing": "문서 확인 중...",
  "invite.upload.success": "성공적으로 업로드되었습니다",
  "invite.upload.next": "다음 문서",
  "invite.upload.finish": "모두 검토",
  "invite.upload.skip": "지금은 건너뛰기",
  "invite.upload.progress": "진행률",
  "invite.complete.title": "완료되었습니다!",
  "invite.complete.subtitle": "귀하의 문서가 성공적으로 제출되었습니다.",
  "invite.complete.message": "모든 문서를 수신했습니다. 곧 연락드리겠습니다.",
  "invite.complete.summary": "제출된 문서",
  "invite.complete.securityNote": "귀하의 문서는 안전하게 저장되며 권한이 있는 담당자만 액세스할 수 있습니다.",
  "invite.chat.title": "담당자와 채팅",
  "invite.chat.placeholder": "메시지를 입력하세요...",
  "invite.chat.empty": "아직 메시지가 없습니다. 대화를 시작하세요.",
  "invite.chat.sent": "메시지가 전송되었습니다.",
  "invite.chat.willRespond": "가능한 빨리 답변드리겠습니다.",
  "invite.chat.sending": "보내는 중...",
  "invite.error.title": "유효하지 않거나 만료된 링크",
  "invite.error.message": "이 초대 링크는 더 이상 유효하지 않습니다. 발송자에게 새 링크를 요청하세요.",
  "common.loading": "로딩 중...",
  "common.save": "저장",
  "common.cancel": "취소",
  "common.delete": "삭제",
  "common.edit": "편집",
  "common.create": "만들기",
  "common.close": "닫기",
  "common.dismiss": "닫기",
  "common.confirm": "확인",
  "common.back": "뒤로",
  "common.next": "다음",
  "common.previous": "이전",
  "common.of": "/",
  "common.search": "검색",
  "common.filter": "필터",
  "common.sort": "정렬",
  "common.viewAll": "모두 보기",
  "common.refresh": "새로고침",
  "common.retry": "다시 시도",
  "common.yes": "예",
  "common.no": "아니요",
  "common.or": "또는",
  "common.and": "그리고",
  "common.optional": "선택사항",
  "common.required": "필수",
  "status.draft": "초안",
  "status.active": "활성",
  "status.pending": "보류 중",
  "status.pending_documents": "문서 보류 중",
  "status.pending_signature": "서명 보류 중",
  "status.on_hold": "보류",
  "status.closed": "완료됨",
  "status.cancelled": "취소됨",
  "error.generic": "문제가 발생했습니다. 다시 시도해 주세요.",
  "error.network": "네트워크 오류. 연결을 확인해 주세요.",
  "error.unauthorized": "이 작업을 수행할 권한이 없습니다.",
  "error.notFound": "요청한 리소스를 찾을 수 없습니다.",
  "error.validation": "입력 내용을 확인하고 다시 시도해 주세요.",
  "error.serverError": "서버 오류. 나중에 다시 시도해 주세요.",
  "success.saved": "변경 사항이 성공적으로 저장되었습니다.",
  "success.created": "성공적으로 생성되었습니다.",
  "success.deleted": "성공적으로 삭제되었습니다.",
  "success.sent": "성공적으로 전송되었습니다.",
  "success.uploaded": "성공적으로 업로드되었습니다.",
  "time.justNow": "방금",
  "time.minutesAgo": "{count}분 전",
  "time.hoursAgo": "{count}시간 전",
  "time.daysAgo": "{count}일 전",
  "time.today": "오늘",
  "time.yesterday": "어제",
  "dealRoom.notFound": "거래를 찾을 수 없습니다",
  "dealRoom.loading": "거래 로딩 중...",
  "dealRoom.conversation.title": "거래 대화",
  "dealRoom.conversation.you": "나",
  "dealRoom.conversation.client": "고객",
  "dealRoom.messages.hideOriginal": "원문 숨기기",
  "dealRoom.messages.original": "원문 ({language})",
  "dealRoom.messages.disabled": "이 거래 상태에서는 메시지가 비활성화됩니다",
  "dealRoom.messages.aiSuggest": "AI 추천 답장",
  "dealRoom.documents.title": "문서",
  "dealRoom.documents.uploadDisabled": "업로드 비활성화됨",
  "dealRoom.documents.pendingAnalysis": "분석 대기 중",
  "dealRoom.documents.uploadFirst": "첫 번째 문서 업로드",
  "dealRoom.documents.uploadHelp": "AI 분석을 위해 이 거래에 문서를 업로드하세요",
  "dealRoom.documents.uploadDisabledHelp": "이 거래 상태에서는 문서 업로드가 비활성화됩니다",
  "dealRoom.documents.analyzeWithAI": "AI로 분석",
  "dealRoom.documents.notAnalyzed": "아직 분석되지 않음",
  "dealRoom.documents.notAnalyzedHelp": "AI 분석을 실행하여 문서 유형, 필드를 추출하고 인사이트를 얻으세요",
  "dealRoom.documents.analyzeDocument": "문서 분석",
  "dealRoom.documents.extractedFields": "추출된 필드",
  "dealRoom.documents.issuesDetected": "감지된 문제",
  "dealRoom.documents.preview": "미리보기",
  "dealRoom.documents.uploaded": "업로드됨",
  "dealRoom.documents.deleteConfirm": "이 문서를 삭제하시겠습니까?",
  "dealRoom.onHold.message": "이 거래가 보류 중입니다. 문서 업로드가 비활성화됩니다. 조율을 위한 메시지는 계속 보낼 수 있습니다.",
  "dealRoom.pendingSignature.message": "계약서가 서명 준비가 되었습니다. 계약서가 서명되거나 되돌릴 때까지 문서 업로드가 비활성화됩니다.",
  "dealRoom.status.current": "현재",
  "dealRoom.status.finalWarning": "이것은 최종 상태입니다. 이 작업 후에는 거래를 다시 열 수 없습니다.",
  "dealRoom.contract.purchaseAgreement": "매매 계약서",
  "dealRoom.contract.purchaseAgreementDesc": "표준 매매 계약서",
  "dealRoom.contract.noContract": "아직 계약서 없음",
  "dealRoom.contract.noContractDesc": "거래 세부 정보와 문서를 기반으로 AI 기반 계약서 초안을 생성하세요.",
  "dealRoom.contract.notAvailable": "{status} 거래에는 계약서 생성을 사용할 수 없습니다.",
  "dealRoom.contract.locked": "서명 대기 중에는 계약서 생성이 잠겨 있습니다.",
  "dealRoom.contract.requiresPlan": "비즈니스 스타터 플랜이 필요합니다",
  "dealRoom.toast.dealUpdated": "거래가 업데이트되었습니다",
  "dealRoom.toast.statusChanged": "거래 상태가 {status}(으)로 변경되었습니다",
  "dealRoom.toast.statusFailed": "상태 변경에 실패했습니다",
  "dealRoom.toast.contractGenerated": "계약서 초안이 성공적으로 생성되었습니다",
  "dealRoom.toast.contractCopied": "{language} 계약서가 클립보드에 복사되었습니다",
  "dealRoom.toast.messageFailed": "메시지 전송에 실패했습니다",
  "dealRoom.toast.suggestionFailed": "제안 생성에 실패했습니다",
  "dealRoom.toast.documentUploaded": "문서가 업로드되었습니다",
  "dealRoom.toast.uploadFailed": "업로드에 실패했습니다",
  "dealRoom.toast.analysisComplete": "AI 문서 분석이 완료되었습니다",
  "dealRoom.toast.analysisFailed": "AI 분석에 실패했습니다",
  "dealRoom.toast.documentDeleted": "문서가 삭제되었습니다",
  "dealRoom.toast.deleteFailed": "삭제에 실패했습니다",
  "dealRoom.details.created": "생성됨",
  "dealRoom.details.addNotes": "거래 메모 추가...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "지금은 건너뛰기",
  "onboarding.badge": "AI 기반 설정",
  "onboarding.welcome": "환영합니다, {name}님!",
  "onboarding.welcomeGeneric": "환영합니다!",
  "onboarding.subtitle": "PocketFiler 작업 공간을 설정해 보겠습니다. AI 컨시어지에게 비즈니스에 대해 알려주시면 모든 것을 구성해 드립니다.",
  "onboarding.step1": "비즈니스와 요구 사항 설명",
  "onboarding.step2": "AI가 설정 제안",
  "onboarding.step3": "거래 관리 시작",
  "onboarding.concierge.title": "AI 컨시어지",
  "onboarding.toast.officeCreated": "가상 오피스가 생성되었습니다!",
  "auth.signup.accountType": "계정 유형",
  "auth.signup.passwordTooShort": "비밀번호는 최소 8자 이상이어야 합니다",
  "auth.signup.passwordsDoNotMatch": "비밀번호가 일치하지 않습니다",
  "auth.signup.success": "계정이 성공적으로 생성되었습니다!",
  "captions.connecting": "연결 중...",
  "captions.disable": "자막 비활성화",
  "captions.enable": "자막 활성화",
  "captions.error.connect": "자막 서비스 연결에 실패했습니다",
  "captions.error.toggle": "자막 전환에 실패했습니다",
  "captions.language": "자막 언어",
  "captions.live": "실시간",
  "captions.off": "자막 꺼짐",
  "captions.on": "자막 켜짐",
  "captions.original": "원본",
  "captions.translated": "번역됨",
  "captions.translating": "번역 중...",
  "clients.joined.empty.desc": "아직 가입한 조직이 없습니다. PocketFiler 작업공간에 초대해달라고 요청하세요.",
  "clients.joined.empty.title": "가입한 조직이 없습니다",
  "clients.nav.joinedOrgs": "가입한 조직",
  "clients.nav.myClients": "내 고객",
  "clients.table.joinedDate": "가입일",
  "clients.table.organization": "조직",
  "common.backToHome": "홈으로 돌아가기",
  "common.deleteConfirmDesc": "이 작업은 되돌릴 수 없습니다. 항목이 영구적으로 삭제되고 서버에서 데이터가 제거됩니다.",
  "common.deleteConfirmTitle": "정말로 삭제하시겠습니까?",
  "common.noResults": "검색 결과가 없습니다",
  "connect.createAccount": "무료 계정 생성",
  "connect.dealCreated": "거래가 성공적으로 생성되었습니다",
  "connect.error.invalid": "유효하지 않은 연결 링크",
  "connect.error.invalidDesc": "이 연결 링크가 유효하지 않거나 만료되었습니다.",
  "connect.error.server": "문제가 발생했습니다",
  "connect.error.serverDesc": "나중에 다시 시도해주세요.",
  "connect.infoUnauth": "이 사용자는 PocketFiler를 사용하여 다국어 거래와 문서를 안전하게 관리합니다.",
  "connect.joinOffice": "가상 오피스 참여",
  "connect.loggedInAs": "로그인:",
  "connect.login": "로그인",
  "connect.startDeal": "거래 시작",
  "connect.titleAuth": "연결 중인 상대",
  "connect.titleUnauth": "연결하기",
  "connect.typeOrg": "조직",
  "connect.typePerson": "개인",
  "contacts.actions.call": "통화",
  "contacts.actions.email": "이메일",
  "contacts.actions.message": "앱 내 메시지 보내기",
  "contacts.actions.noEmail": "이메일 주소 없음",
  "contacts.actions.noPhone": "전화번호 없음",
  "contacts.actions.sms": "문자 메시지",
  "contacts.actions.title": "연락처 {name}",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.dialog.name": "연락처 이름",
  "contacts.dialog.title": "새 연락처 추가",
  "contacts.empty.desc": "첫 번째 연락처를 추가하여 시작하세요.",
  "contacts.empty.title": "연락처가 없습니다",
  "contacts.invite": "연락처 추가",
  "contacts.invite.customNotePlaceholder": "이 연락처에 대한 특별한 메모...",
  "contacts.invite.nameLabel": "연락처 이름",
  "contacts.invite.shareLink": "이 링크를 연락처와 이메일, SMS 또는 직접 공유하세요",
  "contacts.invite.step1Desc": "연락처 정보를 입력하세요",
  "contacts.invite.step1Title": "새 연락처 추가",
  "contacts.subtitle": "연락처와 초대장을 관리하세요",
  "contacts.table.contact": "연락처",
  "contacts.title": "연락처",
  "contacts.toast.deleted": "연락처가 삭제되었습니다",
  "contacts.toast.invited": "연락처 추가됨: {name}",
  "contacts.toast.linkCopied": "링크가 클립보드에 복사되었습니다",
  "dashboard.quickActions.inviteContact": "연락처 추가",
  "dashboard.recentContacts.empty": "연락처가 없습니다. 첫 번째 연락처를 초대하여 시작하세요.",
  "dashboard.recentContacts.title": "최근 연락처",
  "dashboard.recentContacts.viewAll": "전체 보기",
  "dashboard.stats.totalContacts": "전체 연락처",
  "dealRoom.contract.analysisWarning": "일부 문서가 아직 분석되지 않았습니다. AI 분석은 계약서 정확도를 향상시킵니다.",
  "dealRoom.conversation.colleague": "동료",
  "dealRoom.details.clients": "고객",
  "dealRoom.documents.previewNotAvailable": "미리보기를 사용할 수 없습니다. 다운로드 중...",
  "dealRoom.incomingCall.accept": "수락",
  "dealRoom.incomingCall.decline": "거절",
  "dealRoom.incomingCall.inProgress": "통화 진행 중",
  "dealRoom.incomingCall.started": "{name}님이 통화를 시작했습니다",
  "dealRoom.messages.connecting": "채팅에 연결 중...",
  "dealRoom.messages.connectionError": "대화에 연결할 수 없습니다.",
  "dealRoom.pendingSignature.loading": "서명 상태 로딩 중...",
  "dealRoom.pendingSignature.signedWaitingOthers": "서명 완료. 다른 참여자를 기다리는 중입니다.",
  "dealRoom.readOnly.completedMessage": "이 거래가 성공적으로 완료되었습니다. 딜룸은 참조 및 감사 목적으로 읽기 전용이 되었습니다.",
  "dealRoom.signature.signed": "서명됨",
  "dealRoom.signature.signedByYou": "귀하가 서명함",
  "dealRoom.signature.success": "계약서가 성공적으로 서명되었습니다!",
  "dealRoom.signaturesList.clients": "고객",
  "dealRoom.signaturesList.dealOwner": "거래 담당자",
  "dealRoom.signaturesList.pending": "대기 중",
  "dealRoom.signaturesList.signedOn": "서명일",
  "dealRoom.signaturesList.title": "서명",
  "dealRoom.signaturesList.viewSignatures": "서명 보기",
  "dealRoom.signedByAll.addPayment": "결제 추가",
  "dealRoom.signedByAll.message": "모든 참여자가 서명했습니다. 결제를 진행하세요.",
  "dealRoom.timeline.createdBy": "{name}이 생성",
  "deals.tabs.all": "모든 거래",
  "deals.tabs.my": "내 거래",
  "deals.validation.clientRequired": "최소 한 명의 고객을 선택해주세요",
  "deals.validation.notesLength": "메모는 200자 이하여야 합니다",
  "deals.validation.titleLength": "제목은 100자 이하여야 합니다",
  "deals.validation.titleRequired": "거래 제목이 필요합니다",
  "documents.readAloud.analyzeFirst": "소리내어 읽기 위해 먼저 이 문서를 분석하세요.",
  "documents.readAloud.error": "소리내어 읽기에 실패했습니다",
  "documents.readAloud.title": "소리내어 읽기",
  "landing.cta.secondary": "샘플 딜룸 보기",
  "landing.hero.trust": "무료 플랜. 신용카드 불필요. 11개 언어 지원.",
  "landing.socialProof": "40개국 500+ 기업이 신뢰",
  "landing.useCases.personal.desc": "차량, 장비, 부동산 같은 중요한 일회성 거래를 명확한 기록, AI 계약서, 간단한 보안 링크로 문서 공유하여 완료하세요.",
  "landing.useCases.personal.title": "고액 개인 거래",
  "landing.useCases.professional.desc": "고객을 초대하여 AI 지원으로 문서를 업로드하고, 보안 가상 오피스에서 모든 상호작용을 추적하며, 이중 언어 디지털 계약서를 생성하세요. 모든 것을 하나의 작업공간에서.",
  "landing.useCases.professional.subtitle": "보험, 부동산, 대출",
  "landing.useCases.professional.title": "전문 서비스",
  "livekit.call": "통화",
  "livekit.connecting": "연결 중...",
  "livekit.error.connect": "통화 연결에 실패했습니다. 다시 시도해주세요.",
  "livekit.error.connection": "연결 오류입니다. 네트워크를 확인하고 다시 시도해주세요.",
  "livekit.error.permission": "이 통화에 참여할 권한이 없습니다.",
  "livekit.hint": "앱을 전환하는 대신 이 딜 내에서 대화하세요.",
  "livekit.inCall": "통화 중",
  "livekit.joinCall": "통화 참여",
  "livekit.leaveCall": "통화 종료",
  "livekit.participant": "참여자",
  "livekit.participants": "참여자",
  "messages.readAloud.error": "소리내어 읽기에 실패했습니다",
  "messages.readAloud.title": "소리내어 읽기",
  "nav.companyProfile": "회사 프로필",
  "nav.contacts": "연락처",
  "nav.directory": "디렉토리",
  "nav.products": "제품",
  "offices.card.contacts": "{count}개 연락처",
  "pwa.banner.install": "설치",
  "pwa.banner.subtitle": "빠른 접근, 오프라인 작동",
  "pwa.banner.title": "PocketFiler 앱 받기",
  "pwa.firefox.hint": "Firefox에서는 주소 표시줄의 설치 아이콘(⊕)을 찾아 데스크톱에 이 앱을 추가하세요.",
  "pwa.installApp": "앱 설치",
  "pwa.installed": "앱이 성공적으로 설치되었습니다!",
  "pwa.ios.description": "최고의 경험을 위해 PocketFiler를 홈 화면에 추가하세요:",
  "pwa.ios.gotIt": "알겠습니다",
  "pwa.ios.inToolbar": "탭하기",
  "pwa.ios.inTopRight": "탭하기",
  "pwa.ios.shareButton": "공유 버튼",
  "pwa.ios.step1": "브라우저 도구 모음에서",
  "pwa.ios.step2": "아래로 스크롤하여",
  "pwa.ios.step3": "우측 상단의",
  "pwa.ios.title": "PocketFiler 설치",
  "pwa.iosHint": "공유 아이콘을 탭하고 \\\"홈 화면에 추가\\\"를 선택하여 PocketFiler를 설치하세요.",
  "pwa.opera.chromeHint": "이 페이지를 열고 주소 표시줄의 설치 아이콘을 클릭",
  "pwa.opera.desktopNotSupported": "Opera 데스크톱은 PWA 설치를 지원하지 않습니다. PocketFiler를 앱으로 설치하려면 Google Chrome 또는 Microsoft Edge에서 열어주세요.",
  "pwa.opera.edgeHint": "이 페이지를 열고 주소 표시줄의 설치 아이콘(⊕)을 클릭",
  "pwa.opera.mobileAddPage": "페이지 추가",
  "pwa.opera.mobileDescription": "Opera 하단의 + 아이콘을 탭하거나 아래 메뉴를 사용하세요:",
  "pwa.opera.mobileHomeScreen": "홈 화면",
  "pwa.opera.mobileStep1": "Opera 하단 바에서",
  "pwa.opera.mobileStep1b": "더하기(+) 아이콘을 탭",
  "pwa.opera.mobileStep2": "또는",
  "pwa.opera.mobileTitle": "Opera에서 PocketFiler 설치",
  "pwa.opera.recommendedBrowsers": "대신 사용하세요:",
  "pwa.opera.title": "Opera에서는 사용할 수 없음",
  "qr.clickToExpand": "클릭하여 전체 화면으로 보기",
  "qr.copied": "복사됨!",
  "qr.copyLink": "링크 복사",
  "qr.description": "이 코드를 고객이나 파트너에게 보여주세요. 스캔하면 연결되어 몇 초 안에 거래를 시작할 수 있습니다.",
  "qr.download": "다운로드",
  "qr.generate": "QR 코드 생성",
  "qr.linkCopied": "링크가 클립보드에 복사되었습니다",
  "qr.primaryLanguage": "기본 언어",
  "qr.regenerate": "재설정",
  "qr.regenerated": "QR 코드가 재생성되었습니다. 이전 링크는 더 이상 유효하지 않습니다.",
  "qr.scanInstructions": "PocketFiler나 QR 스캐너로 스캔하여 연결하세요.",
  "qr.scanToConnect": "스캔하여 연결",
  "qr.share": "공유",
  "qr.title": "PocketFiler QR 공유",
  "qr.yourLink": "연결 링크:",
  "recording.completed": "녹화 완료",
  "recording.confirmDelete": "이 녹화를 삭제하시겠습니까?",
  "recording.delete": "삭제",
  "recording.deleted": "녹화가 삭제되었습니다",
  "recording.download": "다운로드",
  "recording.error.delete": "녹화 삭제에 실패했습니다",
  "recording.error.noCall": "활성 통화가 없습니다. 먼저 통화에 참여해주세요.",
  "recording.error.start": "녹화 시작에 실패했습니다",
  "recording.error.stop": "녹화 중지에 실패했습니다",
  "recording.failed": "녹화 실패",
  "recording.noRecordings": "녹화된 것이 없습니다",
  "recording.play": "재생",
  "recording.playback": "녹화 재생",
  "recording.processing": "처리 중...",
  "recording.start": "녹화",
  "recording.started": "녹화가 시작되었습니다",
  "recording.stop": "중지",
  "recording.stopped": "녹화가 중지되었습니다. 처리 중...",
  "recording.viewRecordings": "녹화 보기",
  "schedule.button": "일정 예약",
  "schedule.cancel": "취소",
  "schedule.chooseDateTime": "날짜와 시간을 선택해주세요",
  "schedule.create": "예약하기",
  "schedule.created": "예약됨",
  "schedule.dateTime": "날짜 및 시간",
  "schedule.description": "날짜와 시간을 선택하세요. 시간이 되면 통화에 참여할 수 있습니다.",
  "schedule.title": "통화 또는 녹화 예약",
  "schedule.type": "유형",
  "schedule.typeCall": "통화",
  "schedule.typeRecording": "녹화",
  "schedule.upcoming": "예정된 일정",
  "settings.profile.accountType": "계정 유형",
  "settings.profile.accountTypeHelp": "자신에게 가장 적합한 유형을 선택하세요",
  "settings.tabs.sharing": "QR 공유",
  "support.askAI": "AI에게 질문하기",
  "support.availableTimes": "가능한 시간",
  "support.booked": "통화가 성공적으로 예약되었습니다!",
  "support.bookingConfirmed": "좋습니다. {time}에 통화를 예약했습니다. 통화 링크가 포함된 확인서를 받으실 것입니다. 다른 도움이 필요한 것이 있나요?",
  "support.bookingError": "예약에 실패했습니다. 다시 시도해주세요.",
  "support.clearChat": "채팅 지우기",
  "support.error": "메시지 전송에 실패했습니다. 다시 시도해주세요.",
  "support.inYourTime": "현지 시간 기준",
  "support.inputPlaceholder": "질문을 입력하세요...",
  "support.openChat": "AI 지원 열기",
  "support.scheduleCall": "지원팀과 통화 예약",
  "support.scheduleTitle": "지원 통화 예약",
  "support.slotsError": "가능한 시간을 불러오는데 실패했습니다.",
  "support.subtitle": "PocketFiler에 대해 무엇이든 물어보세요",
  "support.title": "AI 지원",
  "support.welcome": "안녕하세요! 저는 PocketFiler AI 어시스턴트입니다. 다음과 같은 도움을 드릴 수 있습니다:\\n\\n- 거래 생성 및 관리\\n- 서명용 문서 전송\\n- QR 연결 기능 사용\\n- 고객 초대\\n- PocketFiler에 대한 기타 질문\\n\\n오늘 무엇을 도와드릴까요?",
  "support.yourTimezone": "시간대",
  "validation.emailInvalid": "이메일 형식이 잘못되었습니다",
  "validation.emailRequired": "이메일이 필요합니다",
  "validation.nameRequired": "이름이 필요합니다",
  "validation.nameTooLong": "이름은 50자 미만이어야 합니다",
  "validation.noteTooLong": "메모는 200자 미만이어야 합니다",
  "validation.phoneInvalid": "전화번호가 잘못되었습니다 (10-15자리)",
  "validation.phoneRequired": "전화번호가 필요합니다",
  "deals.column.cancelled": "취소됨",
  "deals.column.completed": "완료됨",
  "deals.column.disputed": "분쟁 중",
  "deals.column.escrow_funded": "에스크로 입금 완료",
  "deals.column.on_hold": "보류 중",
  "deals.column.pending_documents": "서류 대기 중",
  "deals.column.pending_payment": "결제 대기 중",
  "deals.column.pending_signature": "서명 대기 중",
  "deals.column.release_requested": "해제 요청됨",
  "dashboard.actions.addClient": "고객 추가",
  "dashboard.actions.all": "전체",
  "dashboard.actions.createContract": "계약서 생성",
  "dashboard.actions.createInvoice": "인보이스 생성",
  "dashboard.actions.customize": "사용자 정의",
  "dashboard.actions.newDeal": "새 거래",
  "dashboard.actions.scheduleMeeting": "회의 일정 잡기",
  "dashboard.actions.uploadDocument": "문서 업로드",
  "dashboard.actions.viewAll": "전체 보기",
  "dashboard.briefing.default": "현재 긴급한 사항은 없습니다. 워크스페이스가 양호한 상태입니다.",
  "dashboard.briefing.title": "일일 브리핑",
  "dashboard.empty.activity": "최근 활동이 없습니다.",
  "dashboard.empty.deals": "거래가 없습니다. 첫 번째 거래를 생성하여 파이프라인을 확인하세요.",
  "dashboard.empty.documents": "모든 문서가 최신 상태입니다.",
  "dashboard.empty.meetings": "예정된 회의가 없습니다.",
  "dashboard.empty.tasks": "진행 중인 작업이 없습니다.",
  "dashboard.greeting.afternoon": "좋은 오후입니다",
  "dashboard.greeting.evening": "좋은 저녁입니다",
  "dashboard.greeting.morning": "좋은 아침입니다",
  "dashboard.greeting.subtitle": "워크스페이스 전반에서 일어나고 있는 상황입니다.",
  "dashboard.stats.documents": "문서",
  "dashboard.stats.invoicesDue": "결제 예정 인보이스",
  "dashboard.stats.meetingsComing": "예정된 회의",
  "dashboard.stats.tasksDue": "마감 예정 작업",
  "dashboard.stats.unreadMessages": "읽지 않은 메시지",
  "dashboard.widgets.dealPipeline": "거래 파이프라인",
  "dashboard.widgets.documentsAttention": "검토가 필요한 문서",
  "dashboard.widgets.gettingStarted": "시작하기",
  "dashboard.widgets.quickActions": "빠른 작업",
  "dashboard.widgets.recentActivity": "최근 활동",
  "dashboard.widgets.tasks": "작업",
  "dashboard.widgets.upcomingMeetings": "예정된 회의",
  "dashboard.steps.createDeal": "첫 거래 만들기",
  "dashboard.steps.addClient": "클라이언트 추가",
  "dashboard.steps.uploadDocument": "문서 업로드",
  "dashboard.steps.scheduleMeeting": "회의 예약",
  "dashboard.steps.createInvoice": "청구서 작성",
  "dashboard.steps.addLogo": "로고 추가",
  "dashboard.steps.complete": "완료",
  "dashboard.time.overdue": "기한 초과",
  "dashboard.time.today": "오늘",
  "dashboard.time.tomorrow": "내일",
  "dashboard.time.noDate": "날짜 없음",
  "dashboard.docReason.sent": "전송됨, 응답 대기 중",
  "dashboard.docReason.notAnalyzed": "아직 분석되지 않음",
  "dashboard.docReason.draft": "초안, 미완성",
  "dashboard.docReason.needsReview": "검토 필요",
  "docViewer.notFound": "문서를 찾을 수 없습니다",
  "docViewer.previewUnavailable": "이 파일 형식에 대한 미리보기를 사용할 수 없습니다",
  "docViewer.aiAnalysis": "AI 분석",
  "docViewer.documentType": "문서 유형",
  "docViewer.summary": "요약",
  "docViewer.extractedFields": "추출된 필드",
  "docViewer.issues": "문제",
  "docViewer.tags": "태그",
  "docViewer.noPreviousVersions": "이전 버전이 없습니다",
  "docViewer.noActivity": "아직 활동이 없습니다",
  "auth.forgotPassword.title": "비밀번호 재설정",
  "guestSign.loading": "계약서를 불러오는 중...",
  "guestSign.unableToLoad": "계약서를 불러올 수 없습니다",
  "guestSign.signed": "계약서 서명 완료",
  "guestSign.createOwn": "나만의 계약서를 생성하고 관리하고 싶으신가요?",
  "guestSign.secureSign": "보안 서명",
  "meeting.ended": "이 회의가 종료되었습니다",
  "meeting.cancelled": "회의가 취소되었습니다",
  "meeting.notFound": "회의를 찾을 수 없습니다",
  "meeting.joiningAs": "다음으로 참여:",
  "meeting.yourName": "성명 *",
  "meeting.emailOptional": "이메일 (선택사항)",
  "notFound.title": "페이지를 찾을 수 없습니다",
  "notFound.dashboard": "대시보드로 이동",
  "notFound.home": "홈",
  "auth.resetPassword.invalidLink": "유효하지 않은 링크입니다",
  "auth.resetPassword.title": "새 비밀번호 설정",
  "templates.category": "카테고리",
  "templates.legal": "법무",
  "templates.sales": "영업",
  "templates.services": "서비스",
  "templates.finance": "금융",
  "templates.library": "템플릿 라이브러리",
  "templates.libraryDesc": "비즈니스에 바로 사용할 수 있는 문서 템플릿",
  "templates.noDefault": "검색 조건과 일치하는 기본 템플릿이 없습니다.",
  "templates.noCustom": "사용자 정의 템플릿을 찾을 수 없습니다",
  "templates.delete": "템플릿 삭제",
  "templates.cancel": "취소",
  "uploadRequest.notFound": "요청을 찾을 수 없습니다",
  "uploadRequest.error": "문제가 발생했습니다",
  "uploadRequest.errorDesc": "나중에 다시 시도하거나 이 요청을 보낸 사람에게 문의하십시오.",
  "uploadRequest.uploaded": "문서 업로드 완료!",
  "uploadRequest.title": "문서 업로드 요청",
  "uploadRequest.fileTypes": "PDF, 이미지, Word 문서 - 최대 25MB",
  "verify.verifying": "이메일을 확인하는 중...",
  "verify.success": "이메일 확인 완료!",
  "verify.signIn": "로그인",
  "verify.alreadyVerified": "이미 확인됨",
  "verify.invalidLink": "유효하지 않은 링크",
  "verify.backToLogin": "로그인으로 돌아가기",
  "documents.documents": "문서",
  "documents.allStatus": "전체 상태",
  "documents.newFolder": "새 폴더",
  "documents.clear": "지우기",
  "documents.noDocumentsYet": "아직 문서가 없습니다",
  "documents.status": "상태",
  "documents.type": "유형",
  "documents.uploadedBy": "업로드한 사람",
  "documents.previewNotAvailable": "미리보기를 사용할 수 없습니다",
  "documents.aiAnalysis": "AI 분석",
  "documents.documentType": "문서 유형",
  "documents.summary": "요약",
  "documents.extractedFields": "추출된 필드",
  "documents.issues": "문제점",
  "documents.notYetAnalyzed": "아직 분석되지 않음",
  "documents.details": "상세정보",
  "documents.size": "크기",
  "documents.date": "날짜",
  "documents.mimeType": "MIME 유형",
  "documents.noTags": "태그 없음",
  "documents.changeStatus": "상태 변경",
  "documents.versionHistory": "버전 기록",
  "documents.noPreviousVersions": "이전 버전이 없습니다",
  "documents.activityLog": "활동 로그",
  "documents.noActivityRecordedYet": "아직 기록된 활동이 없습니다",
  "documents.uploadDocuments": "문서 업로드",
  "documents.dragAndDropFiles": "파일을 끌어다 놓거나 클릭하여 찾아보기를 하십시오. PDF, 이미지, Word 문서가 지원됩니다.",
  "documents.shareDocument": "문서 공유",
  "documents.done": "완료",
  "documents.emailOptional": "이메일 (선택사항)",
  "documents.leaveEmptyToJust": "링크만 생성하려면 비워두십시오",
  "documents.messageOptional": "메시지 (선택사항)",
  "documents.cancel": "취소",
  "documents.requestDocuments": "문서 요청",
  "documents.sendASecureUpload": "이메일을 통해 고객에게 보안 업로드 링크를 보내십시오.",
  "documents.clientEmail": "고객 이메일 *",
  "documents.clientName": "고객명",
  "documents.requestedDocuments": "요청된 문서 *",
  "documents.renameFolder": "폴더 이름 변경",
  "documents.selectADestinationFolder": "대상 폴더를 선택하십시오.",
  "documents.deleteDocument": "문서를 삭제하시겠습니까?",
  "settings.individual": "개인",
  "settings.business": "기업",
  "settings.buyer": "구매자",
  "settings.seller": "판매자",
  "settings.chooseYourPreferredTheme": "선호하는 테마를 선택하십시오",
  "settings.light": "밝음",
  "settings.dark": "어둠",
  "settings.system": "시스템",
  "settings.manufacturing": "제조업",
  "settings.insurance": "보험",
  "settings.realEstate": "부동산",
  "settings.automotive": "자동차",
  "settings.importexport": "수출입",
  "settings.other": "기타",
  "settings.brandingWhitelabel": "브랜딩 및 화이트라벨",
  "settings.customizeThePocketfilerExperience": "고객을 위한 PocketFiler 경험을 사용자 정의하십시오.",
  "settings.organizationLogo": "조직 로고",
  "settings.provideADirectLink": "투명한 PNG 또는 SVG 로고에 대한 직접 링크를 제공하십시오.",
  "settings.primaryThemeColor": "기본 테마 색상",
  "settings.selectAHexColor": "브랜드의 기본 강조색을 나타낼 hex 색상 코드를 선택하십시오.",
  "settings.accentHoverColor": "강조 / 호버 색상",
  "settings.selectAHexColor1": "호버 상태, 하이라이트 및 강조 요소에 대한 hex 색상을 선택하십시오.",
  "settings.customDomain": "사용자 정의 도메인",
  "settings.ensureYouConfigureA": "pocketfiler.com을 가리키는 CNAME 레코드를 구성하십시오.",
  "settings.cancellationScheduled": "취소가 예약됨",
  "settings.yourLastPaymentFailed": "마지막 결제가 실패했습니다. 액세스를 유지하려면 결제 방법을 업데이트하십시오.",
  "settings.chooseYourPlan": "요금제를 선택하십시오",
  "settings.monthly": "월간",
  "settings.save20": "20% 절약",
  "settings.current": "현재",
  "settings.popular": "인기",
  "settings.contactSales": "영업 문의",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "PocketFiler 회의를 Google Calendar와 동기화하십시오",
  "settings.settingsPageErrorDebug": "설정 페이지 오류 (디버그)",
  "invoices.createInvoice": "인보이스 생성",
  "invoices.createANewInvoice": "고객을 위한 새 인보이스를 생성하십시오",
  "invoices.selectClient": "고객 선택",
  "invoices.dueDate": "만료일",
  "invoices.clientName": "고객명",
  "invoices.clientEmail": "고객 이메일",
  "invoices.lineItems": "항목",
  "invoices.description": "설명",
  "invoices.qty": "수량",
  "invoices.price": "가격",
  "invoices.tax": "세금 %",
  "invoices.total": "총액",
  "invoices.subtotal": "소계:",
  "invoices.discount": "할인:",
  "invoices.tax1": "세금:",
  "invoices.total1": "총액:",
  "invoices.notesOptional": "메모 (선택사항)",
  "invoices.invoices": "인보이스",
  "invoices.manageAndTrackYour": "인보이스를 관리하고 추적하십시오",
  "invoices.totalInvoiced": "총 인보이스 발행 금액",
  "invoices.paid": "지불됨",
  "invoices.outstanding": "미지불",
  "invoices.totalInvoices": "총 인보이스",
  "invoices.allInvoices": "전체 인보이스",
  "invoices.myInvoices": "내 송장",
  "invoices.receivedInvoices": "수신한 송장",
  "invoices.noInvoicesYet": "아직 송장이 없습니다",
  "meetings.join": "참가",
  "meetings.end": "종료",
  "meetings.meetingTitle": "회의 제목",
  "meetings.date": "날짜",
  "meetings.time": "시간",
  "meetings.duration": "소요 시간",
  "meetings.repeat": "반복",
  "meetings.doesNotRepeat": "반복하지 않음",
  "meetings.weekly": "매주",
  "meetings.every2Weeks": "격주",
  "meetings.monthly": "매월",
  "meetings.invitePeopleOptional": "사람 초대 (선택사항)",
  "meetings.cancel": "취소",
  "meetings.meetings": "회의",
  "companyprofile.companyProfile": "회사 프로필",
  "companyprofile.manageYourBusinessProfile": "비즈니스 프로필과 팀을 관리하세요",
  "companyprofile.publicProfile": "공개 프로필",
  "companyprofile.basicInformation": "기본 정보",
  "companyprofile.essentialDetailsAboutYour": "귀하의 회사에 대한 필수 정보",
  "companyprofile.companyName": "회사명",
  "companyprofile.tagline": "태그라인",
  "companyprofile.industry": "업종",
  "companyprofile.companyType": "회사 형태",
  "companyprofile.description": "설명",
  "companyprofile.companyDetails": "회사 상세정보",
  "companyprofile.additionalInformationAboutYour": "귀하의 비즈니스에 대한 추가 정보",
  "companyprofile.yearEstablished": "설립연도",
  "companyprofile.numberOfEmployees": "직원 수",
  "companyprofile.certifications": "인증서",
  "companyprofile.enterCertificationsSeparatedBy": "인증서를 쉼표로 구분하여 입력하세요",
  "companyprofile.languagesSpoken": "사용 가능한 언어",
  "companyprofile.shippingRegions": "배송 지역",
  "companyprofile.contactInformation": "연락처 정보",
  "companyprofile.howPotentialPartnersCan": "잠재적 파트너가 귀하에게 연락할 수 있는 방법",
  "companyprofile.website": "웹사이트",
  "companyprofile.email": "이메일",
  "companyprofile.phone": "전화번호",
  "companyprofile.country": "국가",
  "companyprofile.city": "도시",
  "companyprofile.address": "주소",
  "companyprofile.teamMembers": "팀 구성원",
  "companyprofile.manageUsersWithinYour": "조직 내 사용자를 관리하세요",
  "companyprofile.role": "역할",
  "companyprofile.admin": "관리자",
  "companyprofile.member": "구성원",
  "companyprofile.viewer": "뷰어",
  "companyprofile.titleOptional": "직함 (선택사항)",
  "companyprofile.name": "이름",
  "companyprofile.title": "직함",
  "companyprofile.status": "상태",
  "companyprofile.actions": "작업",
  "companyprofile.owner": "소유자",
  "companyprofile.copyInviteLink": "초대 링크 복사",
  "companyprofile.removeMember": "구성원 삭제",
  "companyprofile.removeTeamMember": "팀 구성원 삭제",
  "companyprofile.cancel": "취소",
  "products.productsServices": "제품 및 서비스",
  "products.description": "설명",
  "products.pricing": "가격",
  "products.price": "가격",
  "products.unit": "단위",
  "products.details": "상세정보",
  "products.minOrderQty": "최소 주문 수량",
  "products.leadTime": "리드 타임",
  "products.category": "카테고리",
  "products.currency": "통화",
  "products.leadTimeDays": "리드 타임 (일)",
  "products.active": "활성",
  "products.showInCatalog": "카탈로그에 표시",
  "products.cancel": "취소",
  "developersettings.reveal": "공개",
  "developersettings.copy": "복사",
  "developersettings.hide": "숨기기",
  "developersettings.securityWarning": "보안 경고",
  "developersettings.neverShareThisKey": "이 키를 공개적으로 또는 클라이언트측 코드에서 공유하지 마세요",
  "developersettings.anyoneWithThisKey": "이 키를 가진 누구든지 귀하의 데이터를 읽고 수정할 수 있습니다",
  "developersettings.ifCompromisedRevokeImmediately": "손상된 경우 즉시 폐기하고 새 키를 생성하세요",
  "developersettings.iUnderstandAndAccept": "이 키의 보안에 대한 책임을 이해하고 받아들입니다",
  "developersettings.cancel": "취소",
  "developersettings.revealKey": "키 공개",
  "developersettings.accessDenied": "접근 거부",
  "developersettings.onlyBusinessAccountsHave": "비즈니스 계정만 개발자 설정에 접근할 수 있습니다.",
  "developersettings.developerOverview": "개발자 개요",
  "developersettings.manageYourApiKeys": "제3자 통합을 위한 API 키와 Webhook 엔드포인트를 관리하세요.",
  "developersettings.secretApiKeys": "비밀 API 키",
  "developersettings.interactiveApiDocumentationRarr": "대화형 API 문서 &rarr;",
  "developersettings.name": "이름",
  "developersettings.key": "키",
  "developersettings.createdAt": "생성일",
  "developersettings.status": "상태",
  "developersettings.actions": "작업",
  "developersettings.webhookEndpoints": "Webhook 엔드포인트",
  "developersettings.url": "URL",
  "developersettings.events": "이벤트",
  "developersettings.description": "설명",
  "developersettings.done": "완료",
  "developersettings.addWebhookEndpoint": "Webhook 엔드포인트 추가",
  "developersettings.payloadUrl": "Payload URL",
  "developersettings.eventsToSend": "전송할 이벤트",
  "developersettings.sendMeEverything": "모든 것 전송 (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "거래 상태 변경됨 (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "문서 업로드됨 (document.uploaded)",
  "developersettings.descriptionOptional": "설명 (선택사항)",
  "analytics.noDataAvailableFor": "해당 기간에 대한 데이터가 없습니다.",
  "analytics.noDealsFound": "거래를 찾을 수 없습니다.",
  "analytics.noClientDataAvailable": "해당 기간에 대한 고객 데이터가 없습니다.",
  "analytics.client": "고객",
  "analytics.invoices": "송장",
  "analytics.revenue": "수익",
  "analytics.totalPipeline": "총 파이프라인",
  "analytics.noRecentActivityFor": "해당 기간에 대한 최근 활동이 없습니다.",
  "analytics.pipelineOverview": "파이프라인 개요",
  "analytics.goToDeals": "거래로 이동",
  "analytics.analyticsDashboard": "분석 대시보드",
  "analytics.trackYourBusinessPerformance": "비즈니스 성과 및 인사이트를 추적하세요",
  "analytics.last7Days": "지난 7일",
  "analytics.last30Days": "지난 30일",
  "analytics.last90Days": "지난 90일",
  "analytics.lastYear": "지난 해",
  "analytics.overview": "개요",
  "analytics.myPerformance": "내 성과",
  "analytics.currentDealsByStatus": "상태별 현재 거래",
  "analytics.revenueTrendsOverLast": "지난 6개월간 수익 동향",
  "analytics.accountsGeneratingTheMost": "가장 많은 수익을 창출하는 계정",
  "analytics.currentCashFlowOverview": "현재 현금 흐름 개요",
  "analytics.latestBusinessActivitiesAnd": "최신 비즈니스 활동 및 업데이트",
  "compliance.complianceCenter": "컴플라이언스 센터",
  "compliance.hsCodesTariffsSanctions": "HS코드, 관세, 제재 스크리닝, 수출 통제",
  "compliance.hsCodeClassification": "HS코드 분류",
  "compliance.productDescription": "제품 설명",
  "compliance.tariffCalculator": "관세 계산기",
  "compliance.estimateImportDutiesBased": "HS코드 및 무역 경로를 기반으로 수입 관세를 추정합니다.",
  "compliance.hsCode": "HS코드",
  "compliance.declaredValueUsd": "신고 가액 (USD)",
  "compliance.originCountry": "원산지 국가",
  "compliance.destinationCountry": "목적지 국가",
  "compliance.dutyRate": "관세율:",
  "compliance.totalRate": "총 세율:",
  "compliance.estDuty": "추정 관세:",
  "compliance.totalEstCost": "총 추정 비용:",
  "compliance.tradeAgreements": "무역 협정:",
  "compliance.sanctionsScreening": "제재 스크리닝",
  "compliance.screenEntitiesAgainstOfac": "OFAC SDN 목록 및 국가별 제재에 대해 개체를 스크리닝합니다.",
  "compliance.entityName": "개체명",
  "compliance.type": "유형",
  "compliance.company": "회사",
  "compliance.individual": "개인",
  "compliance.vessel": "선박",
  "compliance.countryOptional": "국가 (선택사항)",
  "compliance.usSanctionedCountries": "미국 제재 대상 국가",
  "compliance.exportControlCheck": "수출 통제 확인",
  "compliance.aipoweredEaritarClassificationGuidance": "AI 기반 EAR/ITAR 분류 가이던스. 법적 조언이 아닙니다.",
  "compliance.producttechnologyDescription": "제품/기술 설명",
  "compliance.hsCodeOptional": "HS코드 (선택사항)",
  "compliance.endUseOptional": "최종 용도 (선택사항)",
  "compliance.licenseRequired": "라이선스 필요",
  "compliance.recommendations": "권장사항:",
  "compliance.complianceHistory": "컴플라이언스 기록",
  "compliance.recentComplianceChecksFor": "귀하의 조직에 대한 최근 컴플라이언스 확인입니다.",
  "compliance.noComplianceChecksYet": "컴플라이언스 확인이 아직 없습니다. 위에서 첫 번째 확인을 실행하세요.",
  "intelligence.marketIntelligence": "시장 인텔리전스",
  "intelligence.anonymizedTradeDataAnd": "PocketFiler 플랫폼의 익명화된 무역 데이터 및 벤치마크",
  "intelligence.demandByCategory": "카테고리별 수요",
  "intelligence.whatBuyersAreSourcing": "플랫폼에서 구매자들이 소싱하는 품목 (지난 90일)",
  "intelligence.noDemandDataYet": "수요 데이터가 아직 없습니다. RFQ가 플랫폼에서 생성됨에 따라 데이터가 채워집니다.",
  "intelligence.byIndustry": "산업별",
  "intelligence.noSupplierDataYet": "공급업체 데이터가 아직 없습니다.",
  "intelligence.byCountry": "국가별",
  "intelligence.byType": "유형별",
  "intelligence.byVerification": "검증별",
  "intelligence.noDataYet": "데이터가 아직 없습니다.",
  "intelligence.yourPerformanceVsPlatform": "귀하의 성과 vs 플랫폼",
  "intelligence.seeHowYouStack": "플랫폼 평균과 비교하여 귀하의 순위를 확인하세요",
  "intelligence.completeSomeDealsTo": "벤치마크를 보려면 일부 거래를 완료하세요.",
  "virtualoffices.virtualOffices": "Virtual Offices",
  "virtualoffices.manageYourBrandedWorkspaces": "브랜드 작업공간을 관리하세요",
  "virtualoffices.officeName": "오피스명",
  "virtualoffices.industry": "산업",
  "virtualoffices.languagesServed": "서비스 언어",
  "virtualoffices.descriptionOptional": "설명 (선택사항)",
  "virtualoffices.documentChecklist": "문서 체크리스트",
  "virtualoffices.languages": "언어",
  "tasks.tasks": "작업",
  "tasks.noTasksYet": "작업이 아직 없습니다",
  "tasks.dragTasksHere": "여기로 작업을 드래그하세요",
  "tasks.createNewTask": "새 작업 생성",
  "tasks.descriptionOptional": "설명 (선택사항)",
  "tasks.relatedDealOptional": "관련 거래 (선택사항)",
  "tasks.noDealAttached": "연결된 거래 없음",
  "tasks.assignees": "담당자",
  "tasks.noTeamMembersAvailable": "사용 가능한 팀 멤버가 없습니다. 활성 멤버만 할당 가능합니다.",
  "tasks.cancel": "취소",
  "tasks.description": "설명",
  "tasks.status": "상태",
  "tasks.relatedDeal": "관련 거래",
  "tasks.noAssignees": "담당자 없음",
  "tasks.areYouAbsolutelySure": "정말로 확실하십니까?",
  "events.events": "이벤트",
  "events.tradeShowsWebinarsAnd": "전시회, 웨비나 및 네트워킹 이벤트",
  "events.createEvent": "이벤트 생성",
  "events.title": "제목",
  "events.description": "설명",
  "events.category": "카테고리",
  "events.type": "유형",
  "events.locationUrl": "위치 / URL",
  "events.startDateTime": "시작 날짜 및 시간",
  "events.endDateTime": "종료 날짜 및 시간",
  "events.maxAttendeesOptional": "최대 참석자 수 (선택사항)",
  "events.cancel": "취소",
  "events.allCategories": "모든 카테고리",
  "events.noEventsFoundCreate": "이벤트를 찾을 수 없습니다. 첫 번째 이벤트를 생성하세요!",
  "events.featured": "추천",
  "events.previous": "이전",
  "events.next": "다음",
  "status.pendingDocuments": "문서 대기중",
  "status.pendingSignature": "서명 대기중",
  "status.pendingPayment": "결제 대기중",
  "status.completed": "완료",
  "status.updated": "업데이트됨",
  "status.onHold": "보류",
  "activity.deal": "거래",
  "activity.action.analyzed": "분석됨",
  "activity.action.uploaded": "업로드됨",
  "activity.action.downloaded": "다운로드됨",
  "activity.action.previewed": "미리보기됨",
  "activity.action.shared": "공유됨",
  "activity.action.status_changed": "상태 변경됨",
  "activity.action.updated": "업데이트됨",
  "activity.action.created": "생성됨",
  "activity.action.archived": "보관됨",
  "activity.action.restored": "복원됨",
  "analytics.totalRevenue": "총 매출",
  "analytics.totalDeals": "총 거래 건수",
  "analytics.conversionRate": "전환율",
  "analytics.avgDealValue": "평균 거래 금액",
  "analytics.dealPipeline": "거래 파이프라인",
  "analytics.monthlyRevenue": "월별 매출",
  "analytics.topClientsByRevenue": "매출 기준 상위 고객",
  "analytics.invoiceHealth": "인보이스 상태",
  "analytics.paid": "결제 완료",
  "analytics.pendingPayment": "결제 대기",
  "companyprofile.saveProfile": "프로필 저장",
  "companyprofile.makeVisible": "디렉터리에서 귀하의 회사를 공개합니다",
  "companyprofile.tab.basicInfo": "기본 정보",
  "companyprofile.tab.details": "세부 정보",
  "companyprofile.tab.contact": "연락처",
  "companyprofile.tab.team": "팀",
  "companyprofile.tab.verification": "인증",
  "companyprofile.selectType": "유형 선택",
  "companyprofile.describePlaceholder": "귀하의 회사, 제품 및 서비스에 대해 설명해 주세요...",
  "companyprofile.industry.other": "기타",
  "companyprofile.preview": "미리보기",
  "companyprofile.ph.companyName": "귀하의 회사명",
  "companyprofile.ph.tagline": "품질 제품, 글로벌 도달",
  "companyprofile.ph.selectIndustry": "산업 선택",
  "companyprofile.ph.selectSize": "규모 선택",
  "companyprofile.ph.certifications": "ISO 9001, CE, FDA (쉼표로 구분)",
  "companyprofile.ph.languages": "한국어, 영어, 중국어",
  "companyprofile.ph.exportRegions": "북미, 유럽, 아시아",
  "companyprofile.ph.selectCountry": "국가 선택",
  "companyprofile.ph.city": "로스앤젤레스",
  "companyprofile.ph.teamName": "팀원 이름",
  "companyprofile.ph.addTitle": "직책 추가...",
  "companyprofile.inviteTeamMember": "팀원 초대",
  "companyprofile.invitationSent": "초대장이 성공적으로 발송되었습니다",
  "virtualoffices.newOffice": "새 오피스",
  "virtualoffices.createOffice": "가상 오피스 생성",
  "virtualoffices.reviewChecklist": "문서 체크리스트 검토",
  "virtualoffices.setupDesc": "귀하의 비즈니스를 위한 새로운 브랜드 워크스페이스를 설정하세요",
  "virtualoffices.customizeDesc": "고객에게 필요한 문서를 사용자 정의하세요",
  "virtualoffices.ph.officeName": "예: Garcia Insurance - Auto Policies",
  "virtualoffices.ph.description": "오피스 포커스를 설명하세요...",
  "virtualoffices.ph.addDocument": "사용자 정의 문서 추가...",
  "virtualoffices.generating": "생성 중...",
  "virtualoffices.aiChecklist": "AI 생성 체크리스트:",
  "virtualoffices.clients": "고객",
  "virtualoffices.pending": "대기 중",
  "virtualoffices.invite": "초대",
  "virtualoffices.ind.manufacturing": "제조업",
  "virtualoffices.ind.insurance": "보험업",
  "virtualoffices.ind.real_estate": "부동산업",
  "virtualoffices.ind.automotive": "자동차업",
  "virtualoffices.ind.import_export": "수출입업",
  "virtualoffices.ind.other": "기타",
  "messages.conversations": "대화",
  "messages.searchPlaceholder": "메시지 검색...",
  "messages.noConversations": "대화가 없습니다",
  "messages.send": "전송",
  "messages.selectConversation": "대화 선택",
  "messages.selectConversationDesc": "채팅을 시작하려면 사이드바에서 대화를 선택하십시오",
  "messages.support": "지원",
  "messages.client": "고객",
  "messages.deal": "거래",
  "meetings.subtitle": "화상 회의를 예약하고 관리합니다",
  "meetings.upcoming": "예정된 회의",
  "meetings.past": "지난 회의",
  "meetings.schedule": "예약",
  "meetings.startInstant": "즉시 시작",
  "meetings.startNow": "지금 시작",
  "meetings.noPast": "지난 회의가 없습니다",
  "meetings.noUpcoming": "예정된 회의가 없습니다",
  "meetings.createMeeting": "회의 생성",
  "meetings.startInstantMeeting": "즉시 회의 시작",
  "meetings.scheduleMeeting": "회의 예약",
  "meetings.scheduleDesc": "화상 회의를 예약하고 초대장을 보냅니다.",
  "meetings.invitePeople": "참가자 초대 (선택사항)",
  "meetings.15min": "15분",
  "meetings.30min": "30분",
  "meetings.45min": "45분",
  "meetings.allowRecording": "녹화 허용",
  "meetings.recordingDesc": "호스트가 이 회의를 녹화할 수 있도록 합니다",
  "meetings.waitingRoom": "대기실",
  "meetings.waitingRoomDesc": "참가자는 호스트의 승인을 받은 후 입장할 수 있습니다",
  "meetings.emailPlaceholder": "email@example.com",
  "meetings.cancelConfirm": "이 회의를 취소하시겠습니까?",
  "meetings.cancelMeeting": "회의 취소",
  "documents.title": "문서",
  "documents.viewAll": "전체 보기",
  "documents.archived": "보관됨",
  "documents.requestDocs": "문서 요청",
  "documents.upload": "업로드",
  "documents.allDocuments": "전체 문서",
  "documents.searchPlaceholder": "문서 검색...",
  "documents.addTag": "태그 추가...",
  "documents.uploadDesc": "파일을 드래그 앤 드롭하거나 클릭하여 찾아보세요. PDF, 이미지, Word 문서가 지원됩니다.",
  "documents.emailPlaceholder": "client@example.com",
  "documents.shareMsgPlaceholder": "요청하신 문서입니다...",
  "documents.requestDesc": "이메일을 통해 클라이언트에게 보안 업로드 링크를 보내세요.",
  "documents.namePlaceholder": "홍길동",
  "documents.requestMsgPlaceholder": "다음 문서들을 업로드해 주세요...",
  "documents.folderName": "폴더 이름",
  "documents.selectDestination": "대상 폴더를 선택하세요.",
  "documents.statusUploaded": "업로드됨",
  "documents.statusAnalyzed": "분석됨",
  "documents.statusArchived": "보관됨",
  "documents.allTypes": "전체 유형",
  "documents.inArchive": "보관함에",
  "templates.allTemplates": "모든 템플릿",
  "templates.editTemplate": "템플릿 편집",
  "templates.createCustomTemplate": "사용자 정의 템플릿 생성",
  "templates.editDesc": "문서 템플릿을 업데이트하십시오",
  "templates.createDesc": "재사용 가능한 문서 템플릿을 생성하십시오",
  "templates.ph.templateName": "예: 사용자 정의 NDA",
  "templates.ph.description": "템플릿에 대한 간단한 설명",
  "templates.ph.content": "여기에 템플릿 내용을 입력하십시오...",
  "templates.saving": "저장 중...",
  "templates.creating": "생성 중...",
  "templates.saveChanges": "변경사항 저장",
  "templates.createTemplate": "템플릿 생성",
  "templates.searchPlaceholder": "템플릿 검색...",
  "templates.popularTemplates": "인기 템플릿",
  "templates.defaultTemplates": "기본 템플릿",
  "templates.deleteTemplate": "템플릿 삭제",
  "templates.preview": "미리보기",
  "templates.description": "설명",
  "products.searchPlaceholder": "제품 검색...",
  "products.ph.service": "컨설팅 서비스",
  "products.ph.product": "위젯 프로 3000",
  "products.selectCategory": "카테고리 선택",
  "products.ph.describe": "제품 또는 서비스를 설명하세요...",
  "products.noMatches": "일치하는 결과가 없습니다",
  "products.noProducts": "아직 제품 또는 서비스가 없습니다",
  "products.serviceDetails": "서비스 세부 정보",
  "products.productDetails": "제품 세부 정보",
  "products.inactive": "비활성",
  "products.deleteConfirm": "이 항목을 삭제하시겠습니까?",
  "products.saveChanges": "변경사항 저장",
  "products.addItem": "항목 추가",
  "products.priceOnRequest": "가격 문의",
  "products.perUnit": "단위당",
  "tasks.searchPlaceholder": "작업 검색...",
  "tasks.ph.title": "예: 법률 문서 검토",
  "tasks.ph.description": "이 작업에 대한 추가 정보를 입력하세요...",
  "tasks.selectDeal": "연결할 거래를 선택하세요",
  "tasks.noTasks": "이 열에 작업이 없습니다",
  "tasks.deleteTask": "작업 삭제",
  "settings.tabs.branding": "브랜딩",
  "settings.tabs.payments": "결제",
  "settings.tabs.plan": "플랜",
  "settings.tabs.integrations": "연동",
  "settings.appearance": "외관",
  "settings.saveBranding": "브랜딩 저장",
  "settings.yourPlan": "귀하의 플랜",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "캘린더 피드 URL이 생성되었습니다!",
  "settings.plan.free": "무료",
  "settings.plan.pro": "프로",
  "settings.plan.smallBusiness": "소상공인",
  "settings.plan.businessPro": "비즈니스 프로",
  "settings.plan.scale": "스케일",
  "settings.plan.enterprise": "엔터프라이즈",
  "dealroom.meetings": "회의",
  "dealroom.startMeeting": "회의 시작",
  "dealroom.noMeetings": "이 거래와 연결된 회의가 아직 없습니다",
  "dealroom.noMeetingsDesc": "시작하려면 회의를 시작하거나 예약하십시오",
  "dealroom.failedCreateMeeting": "회의 생성에 실패했습니다",
  "dealroom.finalizedContract": "최종 계약서 — 서명 준비 완료",
  "dealroom.previewNotSupported": "미리보기가 지원되지 않습니다",
  "dealroom.aiMayTakeMoment": "잠시 시간이 걸릴 수 있습니다.",
  "dealroom.aiAnalysisGenerated": "다음 문서에 대한 AI 분석이 생성되었습니다:",
  "dealroom.docsUnanalyzed": "다음 문서는 분석되지 않은 상태로 남아있습니다:",
  "dealroom.analyzingDocs": "문서를 분석하는 중...",
  "dealroom.finalizeWarning": "이 작업은 취소할 수 없습니다. 거래 상태가 서명 대기 중으로 변경되며 모든 당사자가 계약서에 서명할 수 있게 됩니다.",
  "dealroom.cannotRevert": "서명 대기 중 상태에서는 되돌릴 수 없습니다",
  "compliance.ph.productDesc": "예: 스테인리스 스틸 볼트, M10 x 50mm...",
  "compliance.ph.exportDesc": "수출하는 제품 또는 기술에 대해 설명하십시오...",
  "compliance.select": "선택...",
  "compliance.selectCountry": "국가 선택...",
  "events.tradeShow": "무역박람회",
  "events.webinar": "웨비나",
  "events.networking": "네트워킹",
  "events.conference": "컨퍼런스",
  "events.workshop": "워크숍",
  "events.ph.title": "이벤트 제목",
  "events.ph.location": "행사장 주소 또는 회의 URL",
  "events.ph.maxAttendees": "무제한의 경우 빈 칸으로 남겨두십시오",
  "events.searchPlaceholder": "이벤트 검색...",
  "events.cancelRsvp": "RSVP 취소",
  "events.rsvp": "RSVP",
  "rfq.expired": "만료됨",
  "rfq.createRfq": "견적 요청서 작성",
  "rfq.visibility": "공개 범위",
  "rfq.public": "공개 - 모든 공급업체가 볼 수 있음",
  "rfq.private": "비공개 - 초대만",
  "rfq.quantity": "수량",
  "rfq.unit": "단위",
  "rfq.pieces": "개",
  "rfq.kilograms": "킬로그램",
  "rfq.meters": "미터",
  "rfq.squareMeters": "제곱미터",
  "rfq.units": "단위",
  "rfq.sets": "세트",
  "rfq.boxes": "박스",
  "rfq.deliveryLocation": "배송 장소",
  "rfq.deliveryDeadline": "배송 마감일",
  "rfq.specialRequirements": "특별 요구사항",
  "rfq.title": "견적 요청서",
  "rfq.subtitle": "소싱 요청을 검색하거나 직접 게시하십시오",
  "rfq.rfqsPosted": "게시된 RFQ",
  "rfq.openRfqs": "진행 중인 RFQ",
  "rfq.quotesSent": "발송된 견적",
  "rfq.winRate": "낙찰률",
  "rfq.allCategories": "모든 카테고리",
  "rfq.noRfqsFound": "RFQ를 찾을 수 없습니다",
  "rfq.noRfqsYet": "아직 RFQ가 없습니다",
  "meetings.biweekly": "2주마다",
  "meetings.cancelSeries": "전체 시리즈 취소",
  "meetings.cancelThisMeeting": "이 회의 취소",
  "meetings.nextInSeries": "시리즈 다음",
  "nav.contractTemplates": "계약서",
  "contracts.title": "계약서 템플릿",
  "contracts.subtitle": "AI 기반 법률 문서 생성. 시작하려면 템플릿을 선택하세요.",
  "documents.create": "작성",
  "createDoc.untitledDocument": "제목 없는 문서",
  "createDoc.save": "저장",
  "createDoc.export": "내보내기",
  "createDoc.aiAssist": "AI 도우미",
  "createDoc.generate": "생성",
  "createDoc.generating": "생성 중...",
  "createDoc.cancel": "취소",
  "createDoc.translate": "번역",
  "createDoc.translateTitle": "문서 번역",
  "createDoc.translateTo": "번역 대상",
  "createDoc.translateNow": "번역",
  "createDoc.translating": "번역 중...",
  "createDoc.translated": "문서가 성공적으로 번역되었습니다",
  "createDoc.translateFailed": "번역 실패",
  "verification.status": "인증 상태",
  "verification.inProgress": "인증 진행 중",
  "verification.getVerified": "인증 받기",
  "verification.cancelRequest": "요청 취소",
  "verification.submit": "인증 제출",
  "verification.submitting": "제출 중...",
  "verification.uploadDocs": "문서 업로드",
  "verification.level": "인증 수준",
  "verification.selectDocType": "문서 유형 선택...",
  "contracts.generate": "생성",
  "contracts.backToTemplates": "템플릿으로 돌아가기",
  "contracts.required": "필수",
  "contracts.modify": "수정",
  "contracts.finalize": "확정",
  "contracts.applyChanges": "변경 적용",
  "contracts.confirmDelete": "이 초안을 삭제하시겠습니까?",
  "contracts.generating": "문서 생성 중...",
  "templates.deleting": "삭제 중...",
  "templates.noDescription": "설명 없음.",
  "templates.use": "사용",
  "templates.lib.ndaMutual": "상호 비밀유지계약",
  "templates.lib.purchaseAgreement": "구매 계약",
  "templates.lib.serviceAgreement": "서비스 계약",
  "templates.lib.priceQuote": "견적서",
  "templates.lib.invoice": "청구서",
  "templates.lib.loi": "의향서",
  "settings.security": "보안",
  "security.twoFactor": "이중 인증",
  "security.enabled": "활성화됨",
  "security.disabled": "비활성화됨",
  "security.enable2FA": "2FA 활성화",
  "security.disable": "비활성화",
  "security.activeSessions": "활성 세션",
  "security.logoutAll": "모든 곳에서 로그아웃",
  "security.loginHistory": "로그인 기록",
  "security.verify": "확인",
  "security.cancel": "취소",
  "security.password": "비밀번호",
  "security.done": "완료",
  "feedback.button": "피드백",
  "feedback.title": "피드백 보내기",
  "feedback.typeBug": "버그",
  "feedback.typeFeature": "기능",
  "feedback.typeGeneral": "일반",
  "feedback.submit": "제출",
  "feedback.thanks": "감사합니다! 확인하겠습니다.",
};

export default ko;
